import React from "react";
import { FormattedMessage, useIntl, injectIntl } from "react-intl";

export const intlFns = {
  strong: (msg) => `<strong>${msg}</strong>`,
  p: (msg) => `<p>${msg}</p>`,
  red: (msg) => `<span style="color: red; font-weight: bold;">${msg}</span>`,
  green: (msg) => `<span style="color: green; font-weight: bold;">${msg}</span>`,
  blhighlight: (msg) =>
    `<span style="font-size: smaller; color: white; background-color: black; padding: 4px;"><strong>${msg}</strong></span>`,
  br: `<br/>`,
};

export const intlHtmlFns = {
  strong: (msg) => <strong>{msg}</strong>,
  p: (msg) => <p>{msg}</p>,
  br: <br />,
  red: (msg) => <span style={{color: "red", "fontWeight": "bold"}}>{msg}</span>,
  green: (msg) => <span style={{color: "green", "fontWeight": "bold"}}>{msg}</span>,
  blhighlight: (msg) => (
    <span
      style={{
        fontSize: "smaller",
        color: "white",
        backgroundColor: "black",
        padding: "4px;",
      }}
    >
      <strong>{msg}</strong>
    </span>
  ),
};

export const injectIntlHelperHOC = (WrappedComponent) =>
  injectIntl((props) => {
    const { intl } = props;
    const helper = (id, values) =>
      intl.formatMessage(
        {
          id,
        },
        {
          ...intlFns,
          ...values,
        }
      );
    return <WrappedComponent {...props} intlh={helper} />;
  });

const useIntlh = () => {
  const intl = useIntl();
  const intlh = (id, values) =>
    intl.formatMessage(
      {
        id,
      },
      {
        ...intlFns,
        ...values,
      }
    );
  return [intl, intlh];
};

export const FormattedHTMLMessage = ({ id, values = {} }) => {
  return (
    <FormattedMessage
      id={id}
      values={{
        ...intlHtmlFns,
        ...values,
      }}
    />
  );
};

export default useIntlh;
